import { useForm } from 'react-hook-form';
import { useSearchParams } from 'react-router';
import { useEffect, useState } from 'react';
import InputEn from '../../components/InputEn';
import { Button } from '../../components/ui/button';
import Breadcrumb from '../../components/Breadcrumb';
import { SERVICEMANAGE_PAGE } from '../../routes/routeConstant';
import { FileUpload } from '../../components/InputImage';
import useServices from '../../stores/useServices';
import { IService } from '../../types/types';

export default function FormService() {
  const breadcrumbPath = [{ name: 'Service', link: SERVICEMANAGE_PAGE }, { name: 'Form Service' }];
  const { saveLoading, services, fetchServices, addService, editService } = useServices();
  const [searchParams, setSearchParams] = useSearchParams();
  const editId = searchParams.get('edit');
  const [currentImage, setCurrentImage] = useState<string>('/assets/no-data-image.svg');

  const { register, handleSubmit, setValue, reset, watch } = useForm<IService>({
    defaultValues: {
      name_srv_id: '',
      name_srv_en: '',
      description_srv_id: '',
      description_srv_en: '',
      image_srv: '',
    },
  });

  useEffect(() => {
    fetchServices();
  }, [fetchServices]);

  useEffect(() => {
    if (editId) {
      const serviceToEdit = services?.find((service) => service.service_id === Number(editId));
      if (serviceToEdit) {
        setValue('name_srv_id', serviceToEdit.name_srv_id);
        setValue('name_srv_en', serviceToEdit.name_srv_en);
        setValue('description_srv_id', serviceToEdit.description_srv_id);
        setValue('description_srv_en', serviceToEdit.description_srv_en);
        setValue('image_srv', serviceToEdit.image_srv);
        setCurrentImage(serviceToEdit.image_srv || '/assets/no-data-image.svg');
      }
    }
  }, [editId, services, setValue]);

  const onSubmit = async (data: IService) => {
    if (editId) {
      await editService(Number(editId), data);
      setSearchParams({ tab: 'list' });
    } else {
      await addService(data);
      setSearchParams({ tab: 'list' });
    }
    reset();
    setCurrentImage('/assets/no-data-image.svg');
  };

  return (
    <div className="flex gap-4 flex-col">
      <Breadcrumb paths={breadcrumbPath} />
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="flex flex-col gap-3">
          <div className="flex flex-col text-sm gap-2">
            <p className="flex gap-1">
              Name <span className="text-red-600">*</span>
            </p>
            <InputEn
              type="text"
              nama="name_srv_id"
              namaEn="name_srv_en"
              placeholder="Nama layanan..."
              register={register}
              watch={watch}
              setValue={setValue}
            />
          </div>

          <div className="flex flex-col text-sm gap-2">
            <p className="flex gap-1">
              Description <span className="text-red-600">*</span>
            </p>
            <InputEn
              type="textarea"
              nama="description_srv_id"
              namaEn="description_srv_en"
              placeholder="Masukkan deskripsi layanan..."
              register={register}
              watch={watch}
              setValue={setValue}
            />
          </div>

          <div className="flex flex-col text-sm w-full mt-2 gap-2">
            <p className="flex gap-1">
              Image <span className="text-red-600">*</span>
            </p>
            <FileUpload
              setValue={setValue}
              register={register}
              imageFieldName="image_srv"
              defaultImage={currentImage}
            />
          </div>
          <div className="flex gap-2">
            <Button variant="secondary" type="button" onClick={() => setSearchParams({ tab: 'list' })}>
              Batal
            </Button>
            <Button type="submit" disabled={saveLoading}>
              {saveLoading ? 'Menyimpan...' : 'Simpan'}
            </Button>
          </div>
        </div>
      </form>
    </div>
  );
}
